// components/MyAlarm.js
import React, { useEffect, useState } from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";

const MyAlarm = ({ userId }) => {
  const [alarms, setAlarms] = useState([]);

  useEffect(() => {
    // 🔸 실제 Supabase에서 알림 불러오는 로직으로 교체
    const dummyAlarms = [
      { id: 1, message: "예약이 곧 시작됩니다.", time: "2025-04-17 09:30" },
      { id: 2, message: "새로운 공지사항이 도착했습니다.", time: "2025-04-16 14:20" },
    ];
    setAlarms(dummyAlarms);
  }, [userId]);

  return (
    <>
      <Typography variant="h6" gutterBottom>
        내 알림 목록
      </Typography>
      <List>
        {alarms.map((alarm) => (
          <ListItem key={alarm.id} divider>
            <ListItemText
              primary={alarm.message}
              secondary={alarm.time}
            />
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default MyAlarm;
